import { useState } from 'react'
import { Loader, NVButton } from '@nv/basic-components'
import { useGetEvent } from '@nv/hooks'
import BalletBoxIcon from '@nv/images/design/ballet-box-icon'
import ClockIcon from '@nv/images/design/clock-icon'
import TextDocIcon from '@nv/images/design/text-document-icon'
import { AdminVoterService } from '@nv/services'
import { formatDateLocale } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import styles from './AdminEventOverview.module.scss'

export const AdminEventOverview = () => {
  const { eventId } = useParams()
  const { t, i18n } = useTranslation()
  const event = useGetEvent(eventId)
  const currentLanguage = i18n.language
  const [downloading, setDownloading] = useState(false)
  const voteReceiptEnabled = false

  if (!event) return

  const getVoteReceiptReport = async () => {
    setDownloading(true)
    const res = await AdminVoterService.getVoteReceiptReport(event.id, currentLanguage)
    if (res?.success) {
      // @ts-ignore
      const href = URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.download = `Receipt-Report-${event.id}`
      link.href = href
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
    setDownloading(false)
  }

  return (
    <div className={styles['container']}>
      <h1 className={styles['header']}>{t('events.labels.overview')}</h1>
      <div className={styles['header__banner']}>
        <BalletBoxIcon />
        <h2>{event.name[currentLanguage]}</h2>
      </div>

      <div className={styles['content']}>
        <div className={styles['content__section']}>
          <TextDocIcon className={styles['content__icon']} />

          <div className={styles['description-container']}>
            <div className={styles['identifier']}>
              <span className={styles['identifier__label']}>{t('events.labels.identifier')}</span>
              <span className={styles['identifier__value']}>{event.tiviId}</span>
            </div>

            <div className={styles['description']}>
              <span className={styles['description__label']}>{t('events.labels.description')}</span>
              <span className={styles['description__value']}>{event.description && event.description[currentLanguage]}</span>
            </div>
          </div>
        </div>

        <div className={styles['time']}>
          <div className={styles['time__container']}>
            <ClockIcon className={styles['content__icon']} color={'var(--success-color)'} />
            <div className={styles['time__open']}>
              <span className={styles['time__label']}>{t('events.labels.openDate')}</span>
              <span className={styles['time__value']}>{formatDateLocale(event.openDate, currentLanguage)}</span>
            </div>
          </div>
          <div className={styles['time__container']}>
            <ClockIcon className={styles['content__icon']} color={'var(--error-color)'} />
            <div className={styles['time__close']}>
              <span className={styles['time__label']}>{t('events.labels.closeDate')}</span>
              <span className={styles['time__value']}>{formatDateLocale(event.closeDate, currentLanguage)}</span>
            </div>
          </div>
        </div>
      </div>

      {voteReceiptEnabled && !event.multipleVotesEnabled && (
        <>
          {downloading ? (
            <Loader />
          ) : (
            <NVButton height={50} onClick={getVoteReceiptReport} text={t('events.admin.reports.voteReceiptDownload')} />
          )}
        </>
      )}
    </div>
  )
}
